import _ from "lodash";
import React from "react";

import CardSecondary from "@/components/UI/Card/CardSecondary";
import images from "@/utils/images";
import { TextArea } from "@/components/UI/StyledInput";
import { testLocator } from "@/lib/helpers/test-locator";

export const GenericSectionNotes = (props) => {
  const { editable, editHandler, note, profileView, renderExtra, sectionKey, sectionLabel } = props;

  let sectionNote = note.content[sectionKey];

  const [isEditing, setIsEditing] = React.useState(false);
  const [editCopy, setEditCopy] = React.useState(_.cloneDeep(sectionNote));

  let innerContent = (
    <>
      <div>
        <div className="clr-sec float-left d-flex tw:font-bold">
          {sectionLabel} {renderExtra && renderExtra()}
        </div>

        <div className="float-right">
          {editable && !isEditing && (
            <img
              alt="Edit Goals, Objectives, Progress"
              onClick={() => setIsEditing((curr) => !curr)}
              src={images("./icons/edit-2.svg")}
              style={{
                height: "30px",
                width: "30px",
              }}
              {...testLocator(`${sectionKey}EditBtn`)}
            />
          )}

          {editable && isEditing && (
            <img
              alt="Save"
              onClick={() => {
                setIsEditing((curr) => !curr);
                if (editHandler) {
                  editHandler("");
                }
              }}
              src={images("./icons/save.svg")}
              style={{
                height: "30px",
                width: "30px",
              }}
              {...testLocator(`${sectionKey}SaveBtn`)}
            />
          )}
        </div>
      </div>

      <br />

      <div>
        {!isEditing ? (
          <p className="mt-2 text-area-overflow">{sectionNote}</p>
        ) : (
          <TextArea
            onChange={(e) => {
              setEditCopy(e.target.value);

              if (editHandler) {
                editHandler(sectionKey, e.target.value);
              }
            }}
            testId={`${sectionKey}TextArea`}
            value={editCopy}
          />
        )}
      </div>
    </>
  );

  let content;

  if (!profileView) {
    content = (
      <CardSecondary className="mx-0 px-3 py-3 my-3 max-width" style={{ minHeight: 300 }}>
        {innerContent}
      </CardSecondary>
    );
  } else {
    content = (
      <div className="" style={{ minHeight: 300 }}>
        {innerContent}
      </div>
    );
  }

  return <>{content}</>;
};
